import React, { } from 'react';
// background import removed to avoid module resolution issues; use public path instead
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { ImageWithFallback } from './figma/ImageWithFallback';
import { useEffect, useRef } from 'react';
import ctaBg from '../../hero3-bg.jpg';

export function ProjectsPage() {
  const heroRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const $ = (window as any).jQuery as any;
    const pg = (window as any).particleground as any;
    if (!heroRef.current || !$.fn || !pg) return;
    const $el = (window as any).jQuery(heroRef.current);
    if ($el.data('pg-init')) return;
    $el.data('pg-init', true);
    $el.particleground({
      dotColor: 'rgba(93, 101, 107, 0.35)',
      lineColor: 'rgba(93, 101, 107, 0.35)',
      parallax: true,
      parallaxMultiplier:50
    });
    return () => { try { $el.particleground('destroy'); } catch {} };
  }, []);
  const projects = [
    {
      slug: 'frigolive',
      title: 'Frigolive F-007',
      description: 'Tedarik zincirinizde tam kontrol: Konum, sıcaklık, nem, ışık ve darbe verileriyle hassas ürün transferlerinizi garanti altına alın.',
      image: '/frigolive-1.png',
      category: 'IoT & Sensörler',
      features: ['Canlı takip', 'GSM bağlantısı', 'Alarm sistemi', 'Raporlama'],
      tags: ['Lojistik', 'Takip Sistemi', 'GSM']
    },
    {
      slug: 'shalteron',
      title: 'ShalterOn',
      description: '6 röle kontrolü ve 4 dijital input ile gelişmiş otomasyon sistemi. Bahçe sulama, sera kontrolü ve endüstriyel otomasyon için ideal çözüm.',
      image: "/gsm_role.png",
      category: 'Otomasyon',
      features: ['6 röle kontrolü', '4 dijital input', 'Mobil uygulama', 'Zamanlama'],
      tags: ['Otomasyon', 'Sulama', 'Kontrol'],
      androidAppUrl: 'https://play.google.com/store/apps/details?id=com.ilimera.akilli_cihaz_yonetimi&pcampaignid=web_share'
    },
    {
      slug: 'akilli-gecis-sistemi',
      title: 'Akıllı Geçiş Sistemi',
      description: 'QR kod ve mobil uygulama entegrasyonlu modern erişim kontrol sistemi. Okul, ofis ve fabrika girişleri için yoklama ve raporlama özellikleri.',
      image: '/kgs_1.png',
      category: 'Güvenlik Sistemleri',
      features: ['QR kod desteği', 'Mobil uygulama', 'Yoklama sistemi', 'Raporlama'],
      tags: ['Güvenlik', 'Erişim Kontrolü', 'QR Kod'],
      androidAppUrl: ['https://play.google.com/store/apps/details?id=com.ilimera.kartli_gecis_sistemi&pcampaignid=web_share']
    },
    {
      slug: 'depo-takip-sistemi',
      title: 'Depo Takip Sistemi',
      description: 'Forklift ve depo operasyonları için geliştirilmiş anlık takip sistemi. Sensör tabanlı konum belirleme ve kullanıcı yetkilendirme sistemi.',
      image: 'https://images.unsplash.com/photo-1672552226380-486fe900b322?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3YXJlaG91c2UlMjBmb3JrbGlmdCUyMHRyYWNraW5nfGVufDF8fHx8MTc1Njg4MzQwOHww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
      category: 'Lojistik Çözümleri',
      features: ['Anlık forklift takibi', 'Sensör sistemi', 'Kullanıcı yetkilendirme', 'Depo yönetimi'],
      tags: ['Depo', 'Forklift', 'Takip']
    },
    {
      slug: 'sanal-capa-projesi',
      title: 'Sanal Çapa Projesi',
      description: 'Denizcilik sektörü için geliştirilen innovatif çözüm. Fiziksel çapaya ihtiyaç olmadan teknenin sabit konumda kalmasını sağlar.',
      image: 'https://images.unsplash.com/photo-1738339439832-860548f03cc4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxib2F0JTIwYW5jaG9yJTIwbWFyaW5lJTIwdGVjaG5vbG9neXxlbnwxfHx8fDE3NTY4ODM0MDh8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral',
      category: 'Denizcilik Teknolojisi',
      features: ['GPS tabanlı sabit durma', 'Mobil uygulama', 'Kumanda kontrolü', 'Planlı rota'],
      tags: ['Denizcilik', 'GPS', 'Otomasyon']
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="relative py-16 lg:py-20 overflow-hidden">
        {/* Background image */}
        <div aria-hidden className="absolute inset-0 z-0 bg-cover bg-center" style={{ backgroundImage: `url(${ctaBg})` }}></div>
        {/* Dark overlay */}
        <div aria-hidden className="absolute inset-0 z-[5] bg-black/45"></div>
        {/* Particles above overlay */}
        <div ref={heroRef} className="absolute inset-0 z-10 pointer-events-none"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20">
          <div className="text-center">
            <h1 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Ürünlerimiz
            </h1>
            <p className="text-lg text-white max-w-3xl mx-auto">
              İnovatif teknolojilerle geliştirdiğimiz çözümlerimizi keşfedin. 
              Her ürün, müşteri ihtiyaçlarına özel olarak tasarlanmış 
              güvenilir ve verimli sistemlerdir.
            </p>
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {projects                                            /* sanal capa projesi gizlendi */
              .filter((p) => p.slug !== 'sanal-capa-projesi')     /* sanal capa projesi gizlendi */
              .map((project) => (                                 /* sanal capa projesi gizlendi */
              <Card key={project.slug} className="overflow-hidden hover:shadow-lg transition-all duration-300 h-full flex flex-col">
                <div className="aspect-video">
                  <ImageWithFallback
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <CardContent className="p-6 flex flex-col flex-1">
                  <div className="flex items-center justify-between mb-4">
                    <Badge variant="secondary" className="bg-blue-100 text-blue-800">
                      {project.category}
                    </Badge>
                  </div>
                  
                  <h3 className="text-2xl font-bold text-foreground mb-3">
                    {project.title}
                  </h3>
                  
                  <p className="text-muted-foreground mb-4 leading-relaxed">
                    {project.description}
                  </p>

                  <div className="mb-4">
                    <h4 className="font-semibold text-foreground mb-2">Özellikler:</h4>
                    <ul className="grid grid-cols-2 gap-1">
                      {project.features.map((feature, index) => (
                        <li key={index} className="flex items-center text-sm text-muted-foreground">
                          <CheckCircle size={14} className="text-green-500 mr-2 flex-shrink-0" />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="flex flex-wrap gap-2 mb-6">
                    {project.tags.map((tag) => (
                      <Badge key={tag} variant="outline" className="text-xs">
                        {tag}
                      </Badge>
                    ))}
                  </div>

                  <div className="mt-auto">
                    <Link to={`/urunler/${project.slug}`}>
                      <Button className="w-full bg-primary hover:bg-primary/90">
                        Detayları İncele
                        <ArrowRight className="ml-2" size={16} />
                      </Button>
                    </Link>
                  </div>
                </CardContent>
              </Card>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
}